import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { sprintf } from 'sprintf-js';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';
import { BaseService } from './base.service';

// Non-bureau (core) event files. Mirror of EventFileService against the
// /core_events/:eventId/files endpoints. Same shared file/upload_form tables.
@Injectable()
export class CoreEventFileService extends BaseService {

  constructor(
    protected http: HttpClient,
  ) {
    super(http, `${environment.apiBaseUrl}/companies/%(company_id)s/core_events/%(event_id)s/files`);
  }

  listUploadForms(urlParams: any = {}): Observable<any> {
    const url = sprintf(`${environment.apiBaseUrl}/companies/%(company_id)s/core_events/%(event_id)s/upload_forms`, urlParams);
    return this.http.get<any>(url);
  }

  updateUploadForms(model: any, urlParams: any = {}): Observable<any> {
    const url = sprintf(`${environment.apiBaseUrl}/companies/%(company_id)s/core_events/%(event_id)s/upload_forms`, urlParams);
    return this.http.post<any>(url, model);
  }
}
